const SUPABASE_VIDEO_BASE =
  "https://yoqhouniznljdsmpkblf.supabase.co/storage/v1/object/public/presentation-videos";
const THUMB_BASE = `${SUPABASE_VIDEO_BASE}/thumbnails`;

export type PortfolioCase = {
  slug: string;
  title: string;
  client?: string;
  category: "Client project" | "Internal product" | "R&D / Concept";
  region?: string;
  tagline: string;
  description: string;
  highlights: string[];
  stack: string[];
  videoSrc?: string;
  thumbnail?: string;
  accent: string;
};

export const CASES: PortfolioCase[] = [
  {
    slug: "mission-control",
    title: "Mission Control",
    category: "Internal product",
    region: "Global",
    tagline: "Autonomous operations command center for lead engines & multi-agent swarms.",
    description:
      "A dedicated command center that gives full operational visibility into autonomous agent pipelines: scraping, lead intelligence scoring, SDR inbox, agent execution telemetry, and scheduled cron jobs. Embeds live LLM tracing and cost evaluation so every automated decision is deterministic and auditable.",
    highlights: [
      "Real-time telemetric observability across all active agent jobs",
      "Embedded tracing, evaluation and deterministic prompt governance",
      "Self-hosted, high-security infrastructure with zero black-box operations",
    ],
    stack: ["React", "TypeScript", "Convex", "Tailwind CSS", "nginx", "Langfuse"],
    videoSrc: `${SUPABASE_VIDEO_BASE}/mission-control/mission-control-overview.mp4`,
    thumbnail: `${THUMB_BASE}/mission-control.jpg`,
    accent: "linear-gradient(135deg, #7c5cff, #cdfb5f)",
  },
  {
    slug: "openclaw",
    title: "OpenClaw System",
    client: "Chris Lamm",
    category: "Client project",
    region: "USA",
    tagline: "A unified, human-approved AI inbox for high-stakes business communication.",
    description:
      "A production communication platform for Chris Lamm's mortgage brokerage that unifies iMessage, SMS and email into a single inbox, with an AI agent drafting replies in Chris's authentic tone of voice — with strict human approval before dispatch. Isolated on a private network on Chris's dedicated hardware.",
    highlights: [
      "Every AI draft is a private internal note — zero unverified auto-dispatch",
      "Isolated gateway architecture with strict enterprise perimeter security",
      "Persona-matched drafting agent trained on real executive writing style",
      "Production-proven integration with Chatwoot, n8n, and Salesforce",
    ],
    stack: ["Chatwoot", "n8n", "BlueBubbles", "Claude", "Salesforce", "Tailscale", "PostgreSQL", "Redis"],
    videoSrc: `${SUPABASE_VIDEO_BASE}/chris-lamm/studio-os.mp4`,
    thumbnail: `${THUMB_BASE}/openclaw.jpg`,
    accent: "linear-gradient(135deg, #cdfb5f, #2fe6a8)",
  },
  {
    slug: "recrutacis",
    title: "RecrutaCIS",
    client: "Febracis",
    category: "Client project",
    region: "Enterprise",
    tagline: "Two-sided AI recruitment platform for high-volume enterprise hiring.",
    description:
      "An enterprise-scale recruitment platform serving HR teams and candidates with an eight-step assessment journey: resume parsing, live conversational voice AI interview, DISC behavioral profiling, graphology handwriting analysis, and social-media cross-referencing.",
    highlights: [
      "Core infrastructure for enterprise hiring operations",
      "8-step candidate journey with automated scoring and voice AI assessment",
      "Sub-second voice interview engine running on low-latency edge functions",
      "Multi-model fallback chains (OpenAI & Gemini) with fraud-detection engine",
    ],
    stack: ["React", "TypeScript", "Supabase", "n8n", "OpenAI", "Gemini", "Apify", "Docker"],
    videoSrc: `${SUPABASE_VIDEO_BASE}/recrutacis/recrutacis-english-presentation.mp4`,
    thumbnail: `${THUMB_BASE}/recrutacis.jpg`,
    accent: "linear-gradient(135deg, #37d5ff, #7c5cff)",
  },
];

export function getCase(slug: string): PortfolioCase | undefined {
  return CASES.find((c) => c.slug === slug);
}
